import {omit} from '@coolcolduk/util';
import {SessionQuestion} from './sessionQuestionSchema';

/**
 * reset a session question by setting the selectedAnswer to empty string and isCorrect to false.
 * @param question current session question
 * @returns
 */
export function resetSessionQuestion(question: SessionQuestion): SessionQuestion {
  return omit(question, ['selectedAnswer', 'isCorrect']);
}
